export default __webpack_public_path__ + "static/media/IMG_4548-min.d8402ed9.JPG";